module.exports = "/static/assets/d8dd2b39212eb3a266949b79ed400639.png";